import { Col } from '@amzn/stencil-react-components/layout';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import React from 'react';
import styled from '@emotion/styled';


const SpinnerHolder = styled.div`
  background-color: rgba(255,255,255,.5);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  padding-bottom: 100px;
  position: fixed;
  top: 50px;
  width: 100vw;
  z-index: 5;
`;

export default function Loading() {
  return (
    <SpinnerHolder>
      <Col gridGap={16} alignItems="center" justifyContent="center">
        <Spinner size={SpinnerSize.Large} opacity={1} />
      </Col>
    </SpinnerHolder>
  );
}
